// extracted by mini-css-extract-plugin
module.exports = {"root":"AdditionalRates_root__ss3GY","supplementaryText":"AdditionalRates_supplementaryText__9ZZWh"};